import React, {useState} from "react";
import axios from "axios";
import Header2 from "../usalco_lib/Header2";
import styles from './LaunchPad.module.css';
import ReservoirHero from '../components/ReservoirHero';

const defaultUpdates = [
	{
		title: 'Reservoir facelift',
		description: 'The Reservoir update now aligns with the Usalco rebrand, bringing clearer hierarchy and refreshed visuals.',
		meta: 'Rebrand update'
	},
	{
		title: 'The Aqueduct',
		description: 'A new intake channel for bulk Ross data imports, keeping large uploads organized and moving fast.',
		meta: 'New Tool'
	},
	{
		title: 'Ship To Raft',
		description: 'A new Raft stream now centralizes customer Ship To details for faster lookups and handoffs.',
		meta: 'Customer data'
	}
];


export default function LaunchPad() {
	const [updates, setUpdates] = useState(defaultUpdates);
	React.useEffect(() => {
		document.title = "The Reservoir";
		axios.post(window.config.API_URL + 'whats_new/list', {}, { withCredentials: true })
			.then((response) => {
				if(Array.isArray(response.data?.data) && response.data.data.length > 0){
					setUpdates(response.data.data.map((item) => ({
						title: item.wn_title,
						description: item.wn_description,
						meta: item.wn_meta
					})));
				}
			})
			.catch((error) => {
				console.log(error);
			});
		/*
		axios.get(window.config.API_URL+'azure_events', { withCredentials: true }).then((response) => {
			if(response.data.constructor === Array)
				setEvents(response.data);
		});
		*/
		// TODO: abstract API calls out, handle error responses from server
	}, []);

	return (<>
		<Header2 pageName="The Reservoir">
				<div className={styles.launchPadPage}>
					<section className={styles.landing}>
						<section className={styles.landingHeroMedia}>
							<ReservoirHero />
						</section>

					<section className={styles.landingUpdates} id="whats-new">
						<div className={styles.sectionTitle}>
							<h2>What's New</h2>
							<p>Stay up-to-date with the latest Reservoir updates and new features.</p>
						</div>
						<div className={styles.updatesGrid}>
							{updates.map((update, index) => (
								<article key={update.title} className={styles.updateCard} style={{'--delay': `${110 * (index + 1)}ms`}}>
									<h3>{update.title}</h3>
									<p>{update.description}</p>
									<span className={styles.updateCardMeta}>{update.meta}</span>
								</article>
							))}
						</div>
					</section>
				</section>
			</div>
		</Header2>
	</>);
}
